/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import React from 'react'
import SentTime from './SentTime/index'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Inbound/Info"
  
}) {
  return (<React.Fragment
>
<SentTime
  viewPath={`${viewPath}/SentTime`}
/>
{children}
</React.Fragment>)
}